import BgImg from '@assets/jpg/signup-bgs/step-2.jpeg';
import { Button, Form, TextField } from '@components/ui';
import { EmailOutlined } from '@icon';
import { AuthInputSC, AuthTitleSC } from '@pages/auth/auth.styled';
import AuthLayout from '@pages/auth/components/auth-layout';
import Header from '@pages/auth/components/header';
import { resetPassword } from '@services/external/auth.api';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';
import { showNotification } from '../../../../helpers/notification-helper';
import { initialValues, TFormValues, validationSchema } from './reset-password-email.schema';

const ResetPasswordEmail: React.FunctionComponent = () => {
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const { formatMessage } = useIntl();

  const onSubmit = async ({ email }: TFormValues) => {
    setLoading(true);

    try {
      const response = await resetPassword(email);
      history.replace('/reset-password-code', {
        recoveryToken: response.data.recoveryToken,
        email,
      });
    } catch (e: any) {
      showNotification({
        title: formatMessage({ id: 'server_error.something_wrong' }),
        type: 'ERROR',
        copy: '',
      });
    } finally {
      setLoading(false);
    }
  };

  const [, formOptions] = Form.useForm({
    initialValues,
    validationSchema,
    onSubmit,
  });

  return (
    <AuthLayout backgroundImage={BgImg}>
      <div className="form-wrapper forgotten">
        <Header textId="forgotten_password.title" />
        <Form {...formOptions} className="form" showFeedback={false}>
          <AuthTitleSC>
            <FormattedMessage id="reset_password.title" />
          </AuthTitleSC>
          <Form.Field name="email">
            <TextField
              type="email"
              autoComplete="email"
              placeholder={`${formatMessage({ id: 'login.email' })}*`}
              left={<TextField.Icon Icon={EmailOutlined} />}
            />
          </Form.Field>
          <Button type="submit" loading={loading} style={{ marginBottom: 16, marginTop: 16 }}>
            <FormattedMessage id="reset_password.submit" />
          </Button>
          <div className="auth-login-bottom">
            <FormattedMessage
              tagName={'span'}
              id="login.no_account"
              values={{
                link1: (
                  <Link to="/registration" className="auth-reg-link">
                    <FormattedMessage id="login.register" />
                  </Link>
                ),
              }}
            />
          </div>
        </Form>
      </div>
    </AuthLayout>
  );
};

export default React.memo(ResetPasswordEmail);
